const layoutMap = {
    'Full image banner': 'baldininibrxm:fullbanner',
    'Slim image banner': 'baldininibrxm:slimbanner'
}

export default layoutMap
